import React from 'react';
import MediaQuery from 'react-responsive';

const mediaQuerySuffix = '@media ';

const RenderConditionally = ({ query, children }) => (
  <MediaQuery
    query={query.indexOf(mediaQuerySuffix) !== -1
      ? query.substring(mediaQuerySuffix.length)
      : query}
  >
    {children}
  </MediaQuery>
);

export default RenderConditionally;
